import React from 'react';

interface ButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseUp?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  src: string;
  alt: string;
}

const Button: React.FC<ButtonProps> = ({ onClick,onMouseDown,onMouseLeave,onMouseUp, src, alt }) => (
  <button 
  className="no-border" 
  onClick={onClick} 
  onMouseDown={onMouseDown}   
  onMouseLeave={onMouseLeave}    
   onMouseUp={onMouseUp}
   >
    <img src={src} alt={alt} />
  </button>
);

export default Button;
